// Central place for per-page titles and meta descriptions.
// Keys are route paths WITHOUT a trailing slash (except "/").
// Titles: 50-60 chars, descriptions: 140-155 chars, // Inner pages: brand at the end. Home: brand first.

const seoData = {
  "/": {
  title: "MK AI Technologies | AI Automation & Custom Software",
  description:
    "AI voice agents, Twilio IVR, GoHighLevel automation, A2P 10DLC compliance and custom web and mobile apps for growing businesses. Get a free consultation.",
},
  "/about": {
    title: "About MK AI Technologies | AI, Web & Mobile Solutions",
    description:
        "Meet the MK AI Technologies team: developers, designers and strategists building custom web, mobile and AI solutions for businesses locally and globally.",
    },
  "/contact": {
    title: "Contact Us | Get a Free Consultation | MK AI Technologies",
    description:
      "Tell us about your project and get a free consultation. Talk to MK AI Technologies about AI agents, Twilio IVR, A2P 10DLC and web or mobile apps.",
  },
  "/privacy-policy": {
    title: "Privacy Policy | MK AI Technologies",
    description:
      "Read how MK AI Technologies collects, uses and protects your personal information when you use our website and services.",
  },
  "/terms-of-service": {
    title: "Terms of Service | MK AI Technologies",
    description:
      "Read the terms and conditions that apply when you use the MK AI Technologies website and services.",
  },
  "/portfolio/ai-agents": {
    title: "AI Voice Agents & Automation | MK AI Technologies",
    description:
      "Custom AI voice agents that schedule appointments, confirm leads, send reminders and transfer calls to live agents. Built with Vapi, Retell AI or OpenAI.",
  },
  "/portfolio/twilio-ivrs": {
    title: "Twilio IVR Development & Call Routing | MK AI Technologies",
    description:
      "We design and deploy custom Twilio IVR systems for call routing, lead qualification, appointment scheduling and transfers to live agents. Request a quote.",
  },
  "/portfolio/a2p-approval": {
    title: "A2P 10DLC Registration & Approval | MK AI Technologies",
    description:
      "We handle A2P 10DLC brand and campaign registration across Twilio, GoHighLevel and other platforms, so your SMS and MMS messages reach customers.",
  },
  "/portfolio/web-apps": {
    title: "Custom Web App Development Services | MK AI Technologies",
    description:
      "We build high-performance custom web applications, from dashboards and CRMs to e-commerce platforms and admin portals, using full-stack development.",
  },
  "/portfolio/mobile-apps": {
    title: "iOS & Android Mobile App Development | MK AI Technologies",
    description:
      "We build fast, intuitive and scalable iOS and Android apps, from customer engagement and delivery apps to enterprise tools and on-demand services.",
  },
  "/portfolio/ghl-integration": {
    title: "GoHighLevel Setup & Sales Funnels | MK AI Technologies",
    description:
      "We build GoHighLevel sales funnels and landing pages, set up agency sub-accounts, and handle Twilio and A2P 10DLC compliance for your business.",
  },
};

export default seoData;